/**
 * Custom model-indicator toggle (no x-popover dependency).
 */
(function () {
  const ROOT_SELECTOR = "[data-model-indicator]";
  const TOGGLE_SELECTOR = "[data-model-indicator-toggle]";
  const PANEL_SELECTOR = "[data-model-indicator-panel]";

  const getParts = (root) => {
    const toggle = root.querySelector(TOGGLE_SELECTOR);
    const panel = root.querySelector(PANEL_SELECTOR);
    return { toggle, panel };
  };

  const closeIndicator = (root) => {
    const { toggle, panel } = getParts(root);
    if (!toggle || !panel) return;
    root.classList.remove("is-open");
    toggle.setAttribute("aria-expanded", "false");
    panel.hidden = true;
  };

  const openIndicator = (root) => {
    const { toggle, panel } = getParts(root);
    if (!toggle || !panel) return;
    root.classList.add("is-open");
    toggle.setAttribute("aria-expanded", "true");
    panel.hidden = false;
  };

  document.addEventListener(
    "click",
    (event) => {
      const toggle = event.target.closest(TOGGLE_SELECTOR);
      if (toggle) {
        const root = toggle.closest(ROOT_SELECTOR);
        if (!root) return;

        const isOpen = toggle.getAttribute("aria-expanded") === "true";
        const gallery = root.closest("product-gallery");

        gallery?.querySelectorAll(ROOT_SELECTOR).forEach((item) => {
          if (item !== root) closeIndicator(item);
        });

        if (isOpen) {
          closeIndicator(root);
        } else {
          openIndicator(root);
        }
        return;
      }

      document.querySelectorAll(`${ROOT_SELECTOR}.is-open`).forEach((root) => {
        if (!root.contains(event.target)) closeIndicator(root);
      });
    },
    true
  );

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    document.querySelectorAll(`${ROOT_SELECTOR}.is-open`).forEach(closeIndicator);
  });

  document.addEventListener(
    "carousel:change",
    (event) => {
      const carousel = event.target;
      if (!(carousel instanceof Element)) return;
      const gallery = carousel.closest("product-gallery");
      if (!gallery) return;
      gallery.querySelectorAll(ROOT_SELECTOR).forEach(closeIndicator);
    },
    true
  );
})();
